import { Component, OnInit, ViewChild, AfterViewChecked, HostListener, OnDestroy } from '@angular/core';
import { TokenStorageService } from './modules/auth/services/token-storage.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { UserService } from './modules/auth/services/user.service';
import { MotifreclamationService } from './shared/services/motifreclamation';
import { NotifService } from './shared/services/notification.service';

import { User } from './modules/auth/models/user.model';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit , OnDestroy{
  usertype: string;
  currentUser: any;
  isloggedin = false;
  public countdown = 0;
  private countdownSub: Subscription;
  public modalRef: BsModalRef;
  public interval$ = interval(1000);
  private shouldScrollToTop = true;
  role: string;
  isLoggedIn = false;
  showAdminBoard = false;
  showModeratorBoard = false;
  username: string;
  lastname: string;
currentuser: any;
nature: string;
raisonsociale: string;
indicatifagence: string;
login: string;
codebanque: string;
id: string;
motifsub: Subscription;
currentdate: number;
carte: String;
affiliation: String; // Flag to control scrolling

  @ViewChild('childModal', { static: false }) childModal: ModalDirective;
  adminboard: boolean =false;
  notifs: any[]=[];
  notifsub: Subscription;
  totalnotifs: number;

  constructor(
    private token: TokenStorageService,
    private modalService: BsModalService,
    private bnIdle: BnNgIdleService,
    private router: Router,
    private Auth: TokenStorageService,     private notserv: NotifService,

    private userservice: UserService,private mot: MotifreclamationService,
  ) {}

  ngOnInit() {
    this.motifsub = this.mot.motifreclamations$.subscribe(
      (motifs) => {
      //  console.log(motifs[0].currentdate)
        motifs[0]?.currentdate?this.currentdate = motifs[0]?.currentdate:this.currentdate = new Date().getTime();
      }
    )
    this.notifsub = this.notserv.notifs$.subscribe(
      (notifs) => {
this.notifs=notifs   
this.totalnotifs=notifs.length
   }
    )
    this.isLoggedIn = !!this.Auth.getToken();
    if (this.isLoggedIn) {
      this.currentuser = this.Auth.getUser();
      console.log(this.currentuser)
      this.userservice.getUserById(this.currentuser.userId).then(
        (user:User)=>{
          this.role = user.role;
          this.usertype=user.usertype
          this.username = user.firstname;
          this.lastname= user.lastname;
          this.nature=user.nature
          this.raisonsociale=user.raisonsociale
          this.indicatifagence=user.indicatifagence
          this.codebanque=user.banque
          this.login=user.email
          this.id=user._id
          this.carte=user.carte
          this.affiliation=user.affiliation
          this.usertype=='Metier'?this.notserv.getnotifs():''
        }
      )

    }
    this.mot.getmotifreclamationss()
  }
gotologin()
{
  this.router.navigate(['auth/login']); 

}
  returnprofil()
  {
    let profil=''
    if (this.role=='userbanque'&&this.usertype=='Metier')
    {
profil= 'metierbanque'
    }
    else if (this.role=='userbanque'&&this.usertype=='Clientpor'||this.role=='basic'&&this.usertype=='Clientpor')
    {
profil= 'porteur'
    }
    else if (this.role=='userbanque'&&this.usertype=='Clientcomm'||this.role=='basic'&&this.usertype=='Clientcomm')
    {
profil= 'commercant'
    }
    else if (this.role=='userbanque'&&this.usertype=='Agence')
    {
profil= 'agence'
    }
    else if (this.role=='adminbanque')
    {
profil= 'adminbanque'
    }
    else if (this.role=='superadmin')
    {
profil= 'superadmin'
    }
    else if (this.role=='admincomite')
    {
profil= 'presidentcomite'
    }
    else if (this.role=='usercomite')
    {
profil= 'membrecomite'
    }
    return profil
  }
  logout(): void {
    Swal.fire({
      title: 'Vous êtes sur le point de se déconnecter, voulez vous continuer?',     
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Se Déconnecter',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.value) {   
    this.Auth.signOut();
  //  window.location.reload()
        }
      else{       
      }
    }).catch(() => {
      Swal.fire('opération non aboutie!');
    });
  }
  ngOnDestroy() {
    // Clean up subscriptions to avoid memory leaks
    if (this.countdownSub) {
      this.countdownSub.unsubscribe();
    }
  }
}
